"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateController = exports.AddSubtract = void 0;
const ft_types_1 = require("@rivison-inc/ft-types");
const moment_1 = __importDefault(require("moment"));
require("moment-timezone");
var AddSubtract;
(function (AddSubtract) {
    AddSubtract[AddSubtract["ADD"] = 0] = "ADD";
    AddSubtract[AddSubtract["SUBTRACT"] = 1] = "SUBTRACT";
})(AddSubtract = exports.AddSubtract || (exports.AddSubtract = {}));
/**
 * Controller for services
 */
class DateController {
    /**
     * Increase or decrease a date by an amount
     */
    changeDateByFrequency(frequencyType, frequency, addSubtract, date, timeZone) {
        if (!timeZone) {
            throw new Error("timeZone is required");
        }
        if (addSubtract === AddSubtract.ADD) {
            return this.increaseDateByFrequency(frequencyType, frequency, date, timeZone);
        }
        else {
            return this.subtractDateByFrequency(frequencyType, frequency, date, timeZone);
        }
    }
    /**
     * Increase date by frequency
     */
    increaseDateByFrequency(frequencyType, frequency, date, timeZone) {
        if (!timeZone) {
            throw new Error("timeZone is required");
        }
        const type = this.getMomentTypeByFrequencyType(frequencyType);
        const momentDate = moment_1.default(date).tz(timeZone);
        const calculatedDate = momentDate.add(frequency, type);
        return calculatedDate.toISOString();
    }
    /**
     * Subtract date by frequency
     */
    subtractDateByFrequency(frequencyType, frequency, date, timeZone) {
        if (!timeZone) {
            throw new Error("timeZone is required");
        }
        const type = this.getMomentTypeByFrequencyType(frequencyType);
        const momentDate = moment_1.default(date).tz(timeZone);
        const calculatedDate = momentDate.subtract(frequency, type);
        return calculatedDate.toISOString();
    }
    /**
     * Check if a date is before another date
     */
    isBefore(firstDate, secondDate, frequencyType, timeZone) {
        if (!timeZone) {
            throw new Error("timeZone is required");
        }
        const momentFrequencyType = this.getMomentTypeByFrequencyType(frequencyType);
        const momentFirstDate = moment_1.default(firstDate).tz(timeZone);
        const momentSecondDate = moment_1.default(secondDate).tz(timeZone);
        return momentFirstDate.isBefore(momentSecondDate, momentFrequencyType);
    }
    /**
     * Check if a date is after another date
     */
    isAfter(firstDate, secondDate, frequencyType, timeZone) {
        if (!timeZone) {
            throw new Error("timeZone is required");
        }
        const momentFrequencyType = this.getMomentTypeByFrequencyType(frequencyType);
        const momentFirstDate = moment_1.default(firstDate).tz(timeZone);
        const momentSecondDate = moment_1.default(secondDate).tz(timeZone);
        return momentFirstDate.isAfter(momentSecondDate, momentFrequencyType);
    }
    /**
     * Check if a date is the same as another date
     * Same within the frequency type (month, year, etc)
     */
    isSame(firstDate, secondDate, frequencyType, timeZone) {
        if (!timeZone) {
            throw new Error("timeZone is required");
        }
        const momentFrequencyType = this.getMomentTypeByFrequencyType(frequencyType);
        const momentFirstDate = moment_1.default(firstDate).tz(timeZone);
        const momentSecondDate = moment_1.default(secondDate).tz(timeZone);
        return momentFirstDate.isSame(momentSecondDate, momentFrequencyType);
    }
    /**
     * Convert frequency type to moment type
     */
    getMomentTypeByFrequencyType(frequencyType) {
        // === doesn't work here
        if (ft_types_1.FrequencyType.MINUTE == frequencyType)
            return 'minutes';
        if (ft_types_1.FrequencyType.HOUR == frequencyType)
            return 'hours';
        if (ft_types_1.FrequencyType.DAY == frequencyType)
            return 'days';
        if (ft_types_1.FrequencyType.WEEK == frequencyType)
            return 'weeks';
        if (ft_types_1.FrequencyType.MONTH == frequencyType)
            return 'months';
        if (ft_types_1.FrequencyType.YEAR == frequencyType)
            return 'years';
        throw Error(`Frequency Type not found: ${frequencyType}`);
    }
    /**
     * Convert frequency type to moment type
     */
    formatMinimumGranularity(date, frequencyType, minimumGranularity = 'day', timeZone, options) {
        const momentDate = moment_1.default(date).tz(timeZone);
        const frequencyTypeRankings = {
            7: 1,
            6: 2,
            5: 3,
            4: 3,
            3: 4,
            2: 5,
        };
        const minimumGranularityRankings = {
            year: 1,
            month: 2,
            day: 3,
            hour: 4,
            minute: 5,
        };
        const frequencyRank = frequencyTypeRankings[frequencyType];
        const minGranularityRank = minimumGranularityRankings[minimumGranularity];
        const mostGranularRank = Math.max(frequencyRank, minGranularityRank);
        const rankToFormatLong = {
            1: 'YYYY',
            2: 'MMMM YYYY',
            3: 'MMMM D, YYYY',
            4: 'MMMM D, YYYY ha',
            5: 'MMMM D, YYYY h:mma',
        };
        const rankToFormatShort = {
            1: 'YYYY',
            2: 'YYYY-MM',
            3: 'YYYY-MM-DD',
            4: 'YYYY-MM-DD ha',
            5: 'YYYY-MM-DD h:mma',
        };
        const rankToFormat = (options === null || options === void 0 ? void 0 : options.short) ? rankToFormatShort : rankToFormatLong;
        return momentDate.format(rankToFormat[mostGranularRank]);
    }
}
exports.dateController = new DateController();
